import React from 'react';
import DebugSystem from './DebugSystem';

function ComponentViewer({ setPage, user, leagueId, leagueName }) {
    return <DebugSystem setPage={setPage} user={user} leagueId={leagueId} leagueName={leagueName} />;
}

export default ComponentViewer;